/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderShared = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M2 2h8.618l2 4H22v16H2V2zm2 2v16h16V8h-8.618l-2-4H4z" fill="currentcolor" />
      <path
        d="M11 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 3c-1.657 0-3 1.79-3 4h6c0-2.21-1.343-4-3-4zm6 0c-1.657 0-3 1.79-3 4h6c0-2.21-1.343-4-3-4zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFolderShared as FolderShared };
